import type { ReactNode } from "react";
import "./lg-day-night.css";

/*
明るい版の絵と暗い版の絵を両方置き、頁の明暗で片方だけを見せる。
暗い版の絵に filter: brightness を掛けると淡い地が灰色にくすむ (10/23 の撮影の担当の拾い) ので、夜の色の組で塗った別のファイル (*.dark.svg) に替える。
包みは display: contents なので、並びと大きさの決まりは中の img と picture にそのまま当たる。隠した方の img は loading="lazy" なら読み込まれない
*/
export function LgDayNightArt({ day, night }: { day: ReactNode; night: ReactNode }) {
  return (
    <>
      <span className="lg-art-day">{day}</span>
      <span className="lg-art-night">{night}</span>
    </>
  );
}
